import type { CognitoTokenPayload } from '@/schemas/auth-schemas.ts';

export enum LoadUserPropertiesStatus {
    SUCCESS = 'success',
    NO_SESSION = 'no-session',
    INVALID = 'invalid',
}

export type LoadUserPropertiesResult =
    | { status: LoadUserPropertiesStatus.SUCCESS; data: CognitoTokenPayload }
    | { status: LoadUserPropertiesStatus.NO_SESSION }
    | { status: LoadUserPropertiesStatus.INVALID };
